import { render } from "./ColumnGap.vue?vue&type=template&id=d2f9fa28&scoped=true&ts=true"
import script from "./ColumnGap.vue?vue&type=script&lang=ts"
export * from "./ColumnGap.vue?vue&type=script&lang=ts"

import "./ColumnGap.vue?vue&type=style&index=0&id=d2f9fa28&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2f9fa28"]])

export default __exports__